<template>
  <div class="continer">
    <div class="left-content">
      <div class="title">
        <span>审核编号</span>
        <span>工程名称</span>
        <span>建设单位</span>
        <span>审查阶段</span>
      </div>
      <ul>
        <!-- <li v-for="(item,index) in projectList" :key="index">
          <h1>{{item.number}}</h1>
          <h2>{{item.name}}</h2>
          <h3>{{item.unit}}</h3>
          <h4>{{item.stage}}</h4>
        </li> -->
        <iframe :src="this.iframeUrl" width="804" height="404" frameborder="0" scrolling="no" style="
        position:absolute;">
        </iframe>
      </ul>
    </div>
    <div class="right-content">
      <div class="title">
        <h2>通知中心</h2>
      </div>
      <ul>
        <li @click="_getexhibition(item.id)" v-for="(item,index) in notificationCenter.slice(0,8)" :key="index">
          <h5 :title="item.lable">{{item.lable}}</h5>
          <!-- <h6>{{item.creataTime}}</h6> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { notification_query } from '../../api/user/index'
import {  ERR_OK } from '../../api/common/config'
export default {
  data() {
    return {
      notificationCenter:[],
      // iframeUrl:'http://172.18.0.176:15021/project.jsp'
      iframeUrl:'https://st.tlddst.com/project.jsp'
    }
  },
  mounted(){
    this._notification_query()
  },
  methods:{
    _getexhibition(id) {
      this.$router.push({ path: '/blogroll-details',query:{id} })
    },
    _notification_query(){
      notification_query({number:9,page:1}).then((res)=>{
        if( res.data.isok === ERR_OK ) {
          this.notificationCenter = res.data.data.records
          // console.log(res.data.data) 
        }
        // console.log(res)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.continer
  width 1200px
  height 440px
  margin 0  auto
  display flex 
  flex-wrap wrap 
  justify-content space-between
  margin-bottom 32px
  .right-content
    width 370px
    box-shadow 0px 0px 7px 0px rgba(0, 0, 0, 0.06)
    .title 
      height 36px
      background #dfdfdf
      border-radius 4px 4px 0 0 
      font-size 14px
      line-height 36px
      padding 0 30px 
      box-sizing border-box
      h2 
        font-weight bold
    ul  
      height 404px
      border-radius 0 0 4px 4px
      li 
        height 42px
        padding 0 30px
        line-height 42px
        box-sizing border-box
        display flex
        flex-wrap wrap 
        justify-content space-between
        font-size 12px
        cursor pointer
        &:hover 
          background rgba(245,245,245,1)
          color #016BFF
        h5 
          flex 0 0 300px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
  .left-content
    width 804px
    .title
      display flex 
      flex-wrap wrap
      justify-content space-between
      height 36px
      width 100%
      background #e0e0e0
      line-height 36px
      padding 0 45px
      box-sizing border-box
      border-radius 4px
      margin-bottom 2px
      font-size 14px
      span 
        flex 0 0 100px
        font-weight bold
        &:nth-child(2)
          flex 0 0 174px
        &:nth-child(3)
          flex 0 0 186px
        &:nth-child(4)
          flex 0 0 58px
    ul 
      background rgba(255,255,255,1)
      box-shadow 0px 0px 7px 0px rgba(0, 0, 0, 0.06)
      border-radius 6px
      height 404px
      li
        height 42px
        padding 14px 48px 0
        box-sizing border-box
        font-size 12px
        display flex
        flexword-wrap wrap
        justify-content space-between
        &:hover 
          background rgba(245,245,245,1)
          color #016BFF
        h1,h2,h3,h4
          display inline-block
          height 14px
        h1 
          flex 0 0 94px
        h2 
          flex 0 0 174px
        h2,h3
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        h3
          flex 0 0 188px
        h4 
          flex 0 0 50px
</style>
